import { render, staticRenderFns } from "./manageClickLimitQr.vue?vue&type=template&id=b9002020&scoped=true"
import script from "./manageClickLimitQr.vue?vue&type=script&lang=js"
export * from "./manageClickLimitQr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9002020",
  null
  
)

export default component.exports